import { useEffect, useState, useCallback } from "react"
import {
    colorCode,
    safetyPercentage,
    riskProfile,
    riskProfileClickHandler,
} from "../utilities/helpers"

export default function PlaceBadge({ place, mode = "full" }) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)

    // Handle window resize
    useEffect(() => {
        function handleResize() {
            setWindowWidth(window.innerWidth)
        }

        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    // Get appropriate risk profile text based on screen size
    const getRiskText = useCallback(() => {
        const riskText = riskProfile(safetyPercentage(place.overall_safety))

        if (windowWidth <= 400) {
            // For very small screens, use an abbreviated version
            // Example: "MODERATELY SAFE" becomes "MOD SAFE"
            return riskText.replace("MODERATELY", "MOD").toUpperCase()
        }

        return riskText.toUpperCase()
    }, [place.overall_safety, windowWidth])

    useEffect(() => {
        // Register the custom property via JavaScript
        if (window.CSS && window.CSS.registerProperty) {
            try {
                CSS.registerProperty({
                    name: "--progress",
                    syntax: "<percentage>",
                    initialValue: "0%",
                    inherits: true,
                })
            } catch (e) {
                // consoleLog("CSS Property already registered or not supported. [PlaceBadge]")
            }
        }
    }, [])

    return (
        <div>
            <button
                type="button"
                onClick={riskProfileClickHandler}
                className={`btn btn-dark m-1 risk-badge ${mode} ${colorCode(
                    safetyPercentage(place.overall_safety)
                )}`}
                style={{
                    "--badge-progress": `${safetyPercentage(
                        place.overall_safety
                    )}%`,
                }}
            >
                {getRiskText()}
            </button>
        </div>
    )
}
